import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderButton',
  props: {
    icon: { type: String, required: true },
    modelValue: { type: Boolean, required: true }
  },
  emits: [
    'update:modelValue'
],
  setup(__props: any, { expose, emit }) {
  expose();

const props = __props as {
    icon: string,
    modelValue: boolean,
}

_useCssVars(_ctx => ({
  "6a8c4173-icon": (__props.icon)
}))






const __returned__ = { props, emit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})